<div class="nsw-tabs js-tabs">
	<div class="nsw-tabs__list-wrapper">
		<ul class="nsw-tabs__list">
			<ng-container *ngFor="let tab of inputTabs; let i = index">
				<li role="presentation">
					<a (click)="onTabClicked($event, i)" role="tab" [href]="'#section-' + componentId + '-' + i" 
						[class.active]="tab?.active">{{tab.label}}
					</a>
				</li>
			</ng-container>	
		</ul>
	</div>
	
			
	<ng-container *ngFor="let tab of compTabs; let i = index">		
		<section [id]="'section-' + componentId + '-' + i"	style="padding-right : 0;padding-left : 0;"		
			class="nsw-tabs__content" role="tabpanel"						
			[appActiveTab]="tab?.active ? true : false"
			[attr.hidden]="tab?.active ? null : ''">				
			<ng-container *ngIf="tab && null != tab?.template">
				<ng-container *ngTemplateOutlet="tab?.template!"></ng-container>			
			</ng-container>
		</section>
	</ng-container>

</div>
  